import React, { useState } from 'react';
import { mockKhatians } from '../data/mockData';
import { Search, Filter, Eye, Download, FileText, Map, RotateCcw } from 'lucide-react';
import { KhatianDocument } from '../components/KhatianDocument';
export const KhatianViewer: React.FC = () => {
  const [filters, setFilters] = useState({
    division: '',
    district: '',
    upazila: '',
    mouja: '',
    khatianNo: '',
    publishDate: ''
  });
  const [selectedKhatian, setSelectedKhatian] = useState<any>(null);
  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value
    });
  };
  const resetFilters = () => {
    setFilters({
      division: '',
      district: '',
      upazila: '',
      mouja: '',
      khatianNo: '',
      publishDate: ''
    });
  };
  const filteredKhatians = mockKhatians.filter(k => {
    if (k.status !== 'published') return false;
    if (filters.division && k.division !== filters.division) return false;
    if (filters.district && k.district !== filters.district) return false;
    if (filters.upazila && k.upazila !== filters.upazila) return false;
    if (filters.mouja && !k.mouja.toLowerCase().includes(filters.mouja.toLowerCase())) return false;
    if (filters.khatianNo && !k.khatianNo.includes(filters.khatianNo)) return false;
    if (filters.publishDate && k.publishedDate !== filters.publishDate) return false;
    return true;
  });
  return <div className="max-w-7xl mx-auto flex flex-col h-[calc(100vh-8rem)]" data-id="element-402">
      <div className="mb-6" data-id="element-403">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-404">
          Published Khatian Repository
        </h1>
        <p className="text-slate-500" data-id="element-405">
          Search and view finalized land records from DLMS
        </p>
      </div>

      <div className="flex gap-6 flex-1 overflow-hidden" data-id="element-406">
        {/* Main List */}
        <div className={`flex flex-col bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden transition-all duration-300 ${selectedKhatian ? 'w-1/3 hidden lg:flex' : 'w-full'}`} data-id="element-407">
          <div className="p-4 border-b border-slate-200 bg-slate-50" data-id="element-408">
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-3" data-id="element-409">
              <select name="division" value={filters.division} onChange={handleFilterChange} className="input-field py-1.5 text-sm" data-id="element-410">
                <option value="" data-id="element-411">All Divisions</option>
                <option value="Dhaka" data-id="element-412">Dhaka</option>
                <option value="Chittagong" data-id="element-413">Chittagong</option>
                <option value="Rajshahi" data-id="element-414">Rajshahi</option>
                <option value="Khulna" data-id="element-415">Khulna</option>
                <option value="Barisal" data-id="element-416">Barisal</option>
                <option value="Sylhet" data-id="element-417">Sylhet</option>
                <option value="Rangpur" data-id="element-418">Rangpur</option>
                <option value="Mymensingh" data-id="element-419">Mymensingh</option>
              </select>
              <select name="district" value={filters.district} onChange={handleFilterChange} className="input-field py-1.5 text-sm" data-id="element-420">
                <option value="" data-id="element-421">All Districts</option>
                <option value="Dhaka" data-id="element-422">Dhaka</option>
                <option value="Chittagong" data-id="element-423">Chittagong</option>
                <option value="Narayanganj" data-id="element-424">Narayanganj</option>
              </select>
              <select name="upazila" value={filters.upazila} onChange={handleFilterChange} className="input-field py-1.5 text-sm" data-id="element-425">
                <option value="" data-id="element-426">All Upazilas</option>
                <option value="Savar" data-id="element-427">Savar</option>
                <option value="Hathazari" data-id="element-428">Hathazari</option>
                <option value="Rupganj" data-id="element-429">Rupganj</option>
              </select>
              <input type="text" name="mouja" value={filters.mouja} onChange={handleFilterChange} placeholder="Mouja" className="input-field py-1.5 text-sm" data-id="element-430" />
              <input type="text" name="khatianNo" value={filters.khatianNo} onChange={handleFilterChange} placeholder="Khatian No" className="input-field py-1.5 text-sm" data-id="element-431" />
              <input type="date" name="publishDate" value={filters.publishDate} onChange={handleFilterChange} className="input-field py-1.5 text-sm" data-id="element-432" />
            </div>
            <div className="flex justify-end space-x-2" data-id="element-433">
              <button onClick={resetFilters} className="btn-secondary py-1.5 px-3 text-sm flex items-center" data-id="element-434">
                <RotateCcw size={14} className="mr-1" data-id="element-435" /> Reset
              </button>
              <button className="btn-primary py-1.5 px-4 text-sm flex items-center" data-id="element-436">
                <Search size={14} className="mr-1" data-id="element-437" /> Search
              </button>
            </div>
          </div>

          <div className="flex-1 overflow-auto" data-id="element-438">
            <table className="min-w-full divide-y divide-slate-200" data-id="element-439">
              <thead className="bg-slate-50 sticky top-0 z-10" data-id="element-440">
                <tr data-id="element-441">
                  <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-442">
                    Khatian No
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-443">
                    Mouja (JL)
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-444">
                    Owner Name
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-445">
                    Area
                  </th>
                  <th className="px-4 py-3 text-right text-xs font-medium text-slate-500 uppercase" data-id="element-446">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-slate-200" data-id="element-447">
                {filteredKhatians.map(khatian => <tr key={khatian.id} className={`hover:bg-slate-50 cursor-pointer ${selectedKhatian?.id === khatian.id ? 'bg-teal-50' : ''}`} onClick={() => setSelectedKhatian(khatian)} data-id="element-448">
                    <td className="px-4 py-3 whitespace-nowrap text-sm font-bold text-slate-900" data-id="element-449">
                      {khatian.khatianNo}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-600" data-id="element-450">
                      {khatian.mouja} ({khatian.jlNo})
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-900 font-bengali" data-id="element-451">
                      {khatian.ownerName}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-500" data-id="element-452">
                      {khatian.area}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-right text-sm font-medium" data-id="element-453">
                      <button className="text-teal-600 hover:text-teal-900" data-id="element-454">
                        <Eye size={18} data-id="element-455" />
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        {/* Detail Panel */}
        {selectedKhatian && <div className="w-full lg:w-2/3 bg-slate-200 rounded-lg border border-slate-300 shadow-inner flex flex-col overflow-hidden animate-in slide-in-from-right-4" data-id="element-456">
            <div className="p-3 border-b border-slate-300 bg-slate-800 text-white flex justify-between items-center shadow-sm z-10" data-id="element-457">
              <h2 className="font-semibold flex items-center text-sm" data-id="element-458">
                <FileText size={16} className="mr-2 text-teal-400" data-id="element-459" />
                Document View: Khatian {selectedKhatian.khatianNo}
              </h2>
              <div className="flex items-center space-x-3" data-id="element-460">
                <button className="text-slate-300 hover:text-white flex items-center text-xs bg-slate-700 px-2 py-1 rounded" data-id="element-461">
                  <Download size={14} className="mr-1" data-id="element-462" /> Download PDF
                </button>
                <button onClick={() => setSelectedKhatian(null)} className="text-slate-400 hover:text-white p-1" data-id="element-463">
                  ✕
                </button>
              </div>
            </div>

            <div className="p-6 flex-1 overflow-y-auto flex justify-center items-start" data-id="element-464">
              <div className="w-full max-w-4xl shadow-xl" data-id="element-465">
                <KhatianDocument khatian={selectedKhatian} data-id="element-466" />
              </div>
            </div>
          </div>}
      </div>
    </div>;
};